module.exports = __webpack_public_path__ + "assets/img/theX-content-9.8462acd8.png";